'use client';

import { FC, ReactNode } from 'react';
import Twemoji from 'react-twemoji';

const EmojiText: FC<{
	children?: Twemoji['props']['children'] | ReactNode;
}> = ({ children }) => (
	<Twemoji
		options={{
			base: '/assets/',
			folder: 'emoji',
			size: 'svg',
			ext: '.svg',
		}}
		tag="span">
		{children}
	</Twemoji>
);

export default EmojiText;
